<template>
  <div>
    <section class="content-section professionals-search">
      <!-- Busca -->
      <div class="container" v-if="!showResults">
        <span class="section-title">
          <h1>Busca Por Profissionais</h1>
          <h3>
            Encontre um profissional buscando por localização,
            <br>distância ou especialidade
          </h3>
        </span>
        <!-- Busca Endereço -->
        <div class="columns">
          <div class="column">
            <b-field label="Localização">
              <b-autocomplete
                v-model="search.location"
                :data="locationData"
                :keep-first="true"
                @typing="getAsyncData"
                :custom-formatter="val => val.replace(/<[^>]*>?/gm, '')"
              >
                <template slot-scope="props">
                  <div v-html="props.option"></div>
                </template>
                <template slot="empty">
                  Nenhum resultado encontrado
                </template>
              </b-autocomplete>
            </b-field>
            <span>Digite o nome da cidade onde deseja encontrar um profissional</span>
          </div>
          <!-- Distancia máxima -->
          <div class="column">
            <b-field label="Distância">
              <b-input
                v-model="search.maxDistance"
                placeholder="0"
                class="input-distancia short-input"
              />
            </b-field>
            <b-field>
              <b-slider
                v-model="search.maxDistance"
                type="is-primary"
                :value="20"
              />
            </b-field>
            <span>Distância Máx.: <strong class="is-size-5">{{ search.maxDistance }} Km </strong></span>
          </div>
        </div>
        <!-- Especialidades -->
        <div class="columns">
          <div class="column is-half">
            <b-field label="Especialidades">
              <b-taginput
                v-model="tags"
                :data="filteredTags"
                autocomplete
                @typing="getFilteredTags"
              >
                <template slot-scope="props">
                  {{ props.option }}
                </template>
                <template slot="empty">
                  Nenhuma especialidade encontrada
                </template>
              </b-taginput>
            </b-field>
            <a
              class="button is-fullwidth is-primary"
              @click="showResults = true"
            >Buscar</a>
          </div>
        </div>
      </div>

      <!-- Resultados -->
      <div class="container" v-else>
        <h1>Resultado da Busca</h1>
          <h3>
            Estes foram os profissionais encontrados
          </h3>
        <b-button @click="showResults = false" class="is-primary my-2">
          <b-tooltip label="Voltar">
            <b-icon icon="arrow-left"></b-icon>
          </b-tooltip>
        </b-button>
        <div class="my-2">
          <SearchResult
            :location="search.location"
            :maxDistance="search.maxDistance"
            :tags="tags"
          />
        </div>
        <b-button @click="showResults = false" class="is-primary my-2">
          <b-tooltip label="Voltar">
            <b-icon icon="arrow-left"></b-icon>
          </b-tooltip>
        </b-button>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import ProfessionalsCarousel from '@/components/ProfessionalsCarousel/ProfessionalsCarousel'
import SearchResult from './SearchResult'
import { getLocationNameFromCoordinatesMixin } from '../mixins/location.methods'
import specialties from '../utils/specialties'

import axios from 'axios'

export default {
  components: {
    SearchResult
  },
  mixins: [getLocationNameFromCoordinatesMixin],
  data () {
    return {
      filteredTags: [],
      isSelectOnly: false,
      tags: [],
      tagsData: [],
      locationData: [],
      showResults: false,
      selected: null,
      specialties,
      isFetching: false,
      search: {
        location: '',
        maxDistance: 20
      }
    }
  },
  methods: {
    handleSelect (e) {
      console.log(e)
    },
    getFilteredTags (text) {
      this.filteredTags = this.specialties.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .includes(text.toLowerCase())
        )
      })
    },
    searchResultModal () {
      this.$buefy.modal.open({
        parent: this,
        component: ProfessionalsCarousel,
        hasModalCard: true,
        customClass: 'custom-class custom-class-2'
      })
    },
    getAsyncData: debounce(function (query) {
      const APP_ID = '4i6DFMof3BCiqCiun3xm'
      const APP_CODE = 'TSyvE5yaGmjkOo4LtaANVw'
      const BASE_URL = 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json'

      if (!query.length) {
        this.locationData = []
        return
      }

      this.isFetching = true

      axios.get(`${BASE_URL}?app_id=${APP_ID}&app_code=${APP_CODE}&query=${query}&beginHighlight=<b>&endHighlight=</b>&language=pt-br`)
        .then(({ data }) => {
          this.locationData = []
          data.suggestions.forEach((suggestion) => this.locationData.push(suggestion.label))
        })
        .catch((error) => {
          this.locationData = []
          throw error
        })
        .finally(() => {
          this.isFetching = false
        })
    }, 500)
  },
  async mounted () {
    this.$store.dispatch('fetchSpecialties')

    try {
      const { lat, lng } = await this.$getLocation()
      this.$store.commit('setCoordinates', { lat, lng })

      await this.$store.dispatch('getLocationNameFromCoordinates', { lat, lng })
      this.search.location = this.$store.state.locationName
    } catch (error) {
      console.error(error)
    }
  }
}
</script>
